import { c as _c } from "react/compiler-runtime";
import { Icon, TextLink } from '@petsmart-ui/sparky';
import { dataLayerPush, getBaseUrlJoined, layoutEvents, trackMainNavLinkClick } from '@libs/analytics';
import { NAVIGATION_URLS } from '@libs/core';
import type { Banner as BannerEntry } from '../../schema/spaces/ecommerce-petsmart';
import type { Link as LinkType } from '../../types';
import { propsImagesItems } from '../../utils/propsImagesItems';
import type { Card } from '../card-up';
import PromoCard from '../PromoCard';
import { Banner } from '../resolver/banner';
import { transformBanner } from '../resolver/banner/transform';
import type { MarketingSectionProps, MenuBanner as MenuBannerFields } from './types';
import { SPECIAL_TYPES } from './types';
type MenuBannerProps = {
  rightMenuCard: MenuBannerFields;
  onClick: () => void;
};
function MenuBanner(t0) {
  const $ = _c(7);
  const {
    rightMenuCard,
    onClick
  } = t0;
  let T0;
  let t1;
  if ($[0] !== rightMenuCard) {
    const {
      image,
      cta,
      ...fields
    } = rightMenuCard;
    const entry = {
      fields: {
        ...fields,
        image: {
          fields: image
        },
        cta: cta ? {
          fields: {
            ...cta,
            link: {
              fields: cta.link
            }
          }
        } : undefined
      }
    } as unknown as BannerEntry;
    T0 = Banner;
    t1 = transformBanner(entry);
    $[0] = rightMenuCard;
    $[1] = T0;
    $[2] = t1;
  } else {
    T0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== T0 || $[4] !== onClick || $[5] !== t1) {
    t2 = <T0 {...t1} onClick={onClick} />;
    $[3] = T0;
    $[4] = onClick;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
type MenuPromoCardProps = {
  rightMenuCard: Card;
  onClick?: () => void;
};
export function MenuPromoCard(t0) {
  const $ = _c(13);
  const {
    rightMenuCard,
    onClick
  } = t0;
  const {
    link,
    header,
    description,
    image
  } = rightMenuCard;
  const t1 = "link" in rightMenuCard && link ? link as LinkType : undefined;
  const t2 = image.webAltText;
  let t3;
  if ($[0] !== image) {
    t3 = propsImagesItems(image);
    $[0] = image;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = "header" in rightMenuCard && header ? header : "";
  let t5;
  if ($[2] !== link || $[3] !== rightMenuCard) {
    t5 = "link" in rightMenuCard && link && <p className="promo-card__link">Shop now<Icon name="chevron-right" size="sm" /></p>;
    $[2] = link;
    $[3] = rightMenuCard;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== description || $[6] !== image.webAltText || $[7] !== onClick || $[8] !== t1 || $[9] !== t3 || $[10] !== t4 || $[11] !== t5) {
    t6 = <PromoCard data-testid="category-marketing-card" description={description} onClick={onClick} link={t1} imgAlt={t2} imageItems={t3} header={t4}>{t5}</PromoCard>;
    $[5] = description;
    $[6] = image.webAltText;
    $[7] = onClick;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}
export const trackingData = (data: object) => Object.assign(data, {
  ...layoutEvents.headerMenuNavClick
});
export function MarketingSection(t0) {
  const $ = _c(13);
  const {
    rightMenuCard,
    childCategories,
    specialType,
    path
  } = t0;
  let t1;
  if ($[0] !== childCategories || $[1] !== path || $[2] !== rightMenuCard || $[3] !== specialType) {
    const shopAllLink = childCategories?.find(_temp);
    const {
      displayText,
      link
    } = shopAllLink || {};
    let t2;
    if ($[5] !== path || $[6] !== rightMenuCard) {
      t2 = href => {
        if (rightMenuCard) {
          const categoryPath = [...path, rightMenuCard.header].join(" | ");
          trackMainNavLinkClick(categoryPath);
          dataLayerPush(trackingData({
            selection: categoryPath,
            link_url: getBaseUrlJoined(href)
          }));
        }
      };
      $[5] = path;
      $[6] = rightMenuCard;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    const cardClick = t2;
    let t3;
    if ($[8] !== path) {
      t3 = (newPath, href_0) => () => {
        const categoryPath_0 = [...path, newPath].join(" | ");
        trackMainNavLinkClick(categoryPath_0);
        dataLayerPush(trackingData({
          selection: categoryPath_0,
          link_url: getBaseUrlJoined(href_0)
        }));
      };
      $[8] = path;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    const trackClick = t3;
    let t4;
    if ($[10] !== cardClick || $[11] !== rightMenuCard) {
      t4 = type => type === "card" ? <MenuPromoCard rightMenuCard={rightMenuCard as Card} onClick={() => cardClick((rightMenuCard as Card)?.link?.webUrl)} /> : type === "banner" ? <MenuBanner rightMenuCard={rightMenuCard as MenuBannerFields} onClick={() => cardClick((rightMenuCard as MenuBannerFields)?.cta?.link?.webUrl)} /> : null;
      $[10] = cardClick;
      $[11] = rightMenuCard;
      $[12] = t4;
    } else {
      t4 = $[12];
    }
    const renderedComponent = t4;
    const shopByBrandHref = NAVIGATION_URLS.legacy.shopByBrand;
    t1 = specialType === SPECIAL_TYPES.SHOP_BY_BRAND ? <div className="submenu-container__data"><div id="all-brands-link"><a href={shopByBrandHref} onClick={trackClick("Shop all Brands", shopByBrandHref)}><p>{"Shop all Brands"}</p></a></div></div> : <div className="submenu-container__data">{renderedComponent(rightMenuCard?.sysType)}{shopAllLink && displayText && <TextLink href={link} onClick={trackClick(displayText, link)} variant="secondary" className="category__link--shopall" data-testid="category-shopall">{displayText}<Icon name="chevron-right" size="md" /></TextLink>}</div>;
    $[0] = childCategories;
    $[1] = path;
    $[2] = rightMenuCard;
    $[3] = specialType;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}
function _temp(t0) {
  const {
    shopAllCategory
  } = t0;
  return shopAllCategory;
}